import 'intersection-observer';
import MD5 from 'md5';

import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_PAGE, TRACKING_OP_TYPE, TRACKING_TYPE } from '@/utils/tracking/constants';
import reporter from './report';
import { dispatchTrack } from './tracking';
// 延迟安全引用：initStore
import coreStore from '@/stores/core';

const reportImpression = (trackingname = '', trackingdata = '', trackingpage = TRACKING_PAGE.MAIN_PAGE) => {
  if (trackingdata) {
    try {
      if (typeof trackingdata === 'string') {
        trackingdata = JSON.parse(trackingdata);
      }
    } catch (error) {
      trackingdata = {};
    }
  } else {
    trackingdata = {};
  }

  const initStore = coreStore.safeGetStore('initStore');
  dispatchTrack({
    page: trackingpage,
    operation: TRACKING_OPERATION.IMPRESSION,
    section: TRACKING_SECTION[trackingname] || '',
    target: TRACKING_TARGET[trackingname] || '',
    data: {
      viewed_objects: [
        // impression 统一补充
        {
          chat_session_id: initStore.sessionId || '',
          ...trackingdata,
        },
      ],
    },
  });
};

// 用 tr 上报 impression 方便 grafana 制作面板
const reportTrImpression = (label = '') => {
  reporter.apiBatchReport({
    type: 'count',
    value: { label },
  });
};

const viewTimerList = {};
export const io = new IntersectionObserver(
  entries => {
    for (const entry of entries) {
      const {
        trackingname = '',
        trackingindex = '',
        trackingdata = '',
        trackingoptype = '',
        trackingOnce,
        trackingpage = TRACKING_PAGE.MAIN_PAGE,
      } = entry.target.dataset;
      const trackingkey = MD5(trackingname + trackingindex + trackingdata + trackingpage);
      if (viewTimerList[trackingkey]) {
        clearTimeout(viewTimerList[trackingkey]);
        viewTimerList[trackingkey] = null;
      }
      if (entry.intersectionRatio > 0.5) {
        viewTimerList[trackingkey] = setTimeout(() => {
          reportImpression(trackingname, trackingdata, trackingpage);
          if (trackingoptype === TRACKING_OP_TYPE.API_BATCH_REPORT && trackingname === TRACKING_TYPE.SHORTCUT) {
            reportTrImpression('live_agent_shortcut_impression');
          }

          if (trackingOnce) {
            removeObserver(entry.target);
          }
        }, 1001); // 超过1s上报
      }
    }
  }, { threshold: [0.5] },
);

const handleIo = (ref, func) => {
  try {
    if (Array.isArray(ref)) {
      ref.forEach(element => {
        const target = element;
        if (Array.isArray(target)) {
          io[func](target[0]);
        } else {
          io[func](target);
        }
      });
    } else {
      io[func](ref);
    }
  } catch (err) {
    // do nothing
  }
};

export const addObserver = (ref) => {
  handleIo(ref, 'observe');
};

export const removeObserver = (ref) => {
  handleIo(ref, 'unobserve');
};
